import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import {
  _post,
  DeserializeVoid,
} from '../../../../../../../../../services/base.service';
import { map } from 'rxjs/operators';
import { SignDetail } from '../../../../../../../../../model/sign/sign-detail';
import { SignWithStockAmount } from '../../../sign-with-stock-amount';

@Injectable({
  providedIn: 'root',
})
export class ClientOrderStockControllerRequestService {
  private static BASE_URL = '/sign-stock';
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      ClientOrderStockControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public orderStock(
    signWithStockAmount: SignWithStockAmount,
    companyId: number,
    amounts: number[],
    directOrder: boolean,
    message: string
  ): Promise<StockOrderedEvent> {
    const sign = signWithStockAmount as SignDetail;

    if (!sign.id) {
      throw new Error('Sign ID is required for ordering stock');
    }

    const signId = sign.id; // Store in a variable to ensure type narrowing

    const extras: string[] = [];
    if (sign.material) extras.push(sign.material);
    if (sign.specialShape?.value) extras.push('Kapvorm');
    if (sign.reflectable?.value) extras.push('Reflecterend');
    if (sign.descending) extras.push('Aflopend');

    const format = sign.signMeasurements
      ? `${sign.signMeasurements.width} x ${sign.signMeasurements.height} cm`
      : '';

    // Format model with title and phone number
    const modelParts: string[] = [];
    if (sign.title) modelParts.push(sign.title);
    if (sign.phoneNumber) modelParts.push(sign.phoneNumber);
    const model = modelParts.join(' - ');

    const body: RequestBody = {
      signId: signId,
      companyId: companyId,
      amounts: amounts,
      directOrder: directOrder,
      message: message,
      signType: sign.type?.label === 'IP' ? 'IP Bord' : sign.type?.label || '',
      signModel: model,
      signFormat: format,
      signExtras: extras,
      displayPrices: sign.displayPrices,
    };
    return this.post('/client-order-stock', body, DeserializeVoid)
      .pipe(
        map(() => ({
          signId,
          stockIncreases: amounts,
          isDirectOrder: directOrder,
        }))
      )
      .toPromise();
  }
}

interface RequestBody {
  signId: number;
  companyId: number;
  amounts: number[];
  directOrder: boolean;
  message: string;
  signType: string;
  signModel: string;
  signFormat: string;
  signExtras: string[];
  displayPrices: boolean;
}

export interface StockOrderedEvent {
  signId: number;
  stockIncreases: number[];
  isDirectOrder: boolean;
}
